var map = {
	"./address_image.svg": 128,
	"./amity_university.png": 129,
	"./animated_ashutosh.png": 130,
	"./animated_logo.svg": 131,
	"./blogs_image.svg": 132,
	"./bsnl_logo.webp": 133,
	"./cloud_infrastructure.svg": 134,
	"./codeInLogo.png": 135,
	"./contactMail.png": 136,
	"./coursera_logo.png": 137,
	"./data_science.svg": 138,
	"./deeplearning_ai_logo.png": 139,
	"./delhivery_logo.png": 140,
	"./developer.svg": 141,
	"./developerActivity.svg": 142,
	"./dsc_logo.png": 143,
	"./education.svg": 144,
	"./experience.svg": 145,
	"./feelingProud.svg": 146,
	"./freecopy_logo.png": 147,
	"./fullstack.svg": 148,
	"./gcp_logo.png": 149,
	"./github_logo.png": 150,
	"./googleAssistant.jpg": 151,
	"./googleAssistant.svg": 152,
	"./google_logo.png": 153,
	"./ibm_logo.png": 154,
	"./iiitk_logo.png": 155,
	"./intel_logo.jpg": 156,
	"./iu_logo.png": 157,
	"./jsFramework.svg": 158,
	"./legato_logo.png": 159,
	"./manOnTable.svg": 160,
	"./microsoft_logo.png": 161,
	"./misys_logo.jpeg": 162,
	"./mozilla_logo.png": 163,
	"./muffito_logo.png": 164,
	"./n26_logo.webp": 165,
	"./nextuLogo.jpg": 166,
	"./nptel_logo.png": 167,
	"./onedirect.png": 168,
	"./oxford_logo.jpeg": 169,
	"./portfolio.gif": 170,
	"./programmer.svg": 171,
	"./projects_image.svg": 172,
	"./pwa.png": 173,
	"./saayaHealthLogo.png": 174,
	"./stanford_logo.png": 175,
	"./talksCardBack.svg": 176,
	"./talksCardBackAlt.svg": 177,
	"./teams copy.svg": 178,
	"./teams.svg": 179,
	"./tiktok_logo.png": 180,
	"./ui_ux_design.svg": 181
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 32;